import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '../../../store/slices/authSlice';
import ErrorLayout from '../components/ErrorLayout';
import { useThemeContext } from '../../../components/ThemeProvider';
import { useCommonTranslation } from '../../../hooks';

const Error404 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const { primaryColor } = useThemeContext();
  const { t } = useCommonTranslation();

  const getRedirectPath = () => {
    if (!isAuthenticated) return '/login';
    return '/dashboard';
  };

  const handleGoBack = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate(getRedirectPath(), { replace: true });
    }
  };

  const handleGoHome = () => {
    navigate(getRedirectPath(), { replace: true });
  };

  return (
    <ErrorLayout
      code={404}
      title={t('errorPages.404.title')}
      message={t('errorPages.404.message', { path: location.pathname })}
      action={
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button 
            onClick={handleGoBack}
            className="px-6 py-3 rounded-lg text-gray-700 dark:text-gray-200 font-medium border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          >
            {t('errorPages.404.goBack')}
          </button>
          <button 
            onClick={handleGoHome}
            className="px-6 py-3 rounded-lg text-white font-medium hover:opacity-90 transition-opacity"
            style={{ backgroundColor: primaryColor || '#1E40AF' }}
          >
            {isAuthenticated ? t('errorPages.404.goDashboard') : t('errorPages.404.login')}
          </button>
        </div>
      }
    />
  );
};

export default Error404;
